<a
  class="btn btn-flex gap-2 flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100"
  [routerLink]="[PAGE_ROUTES()['HELPDESK']]"
>
  <ui-keenicon name="document" class="fs-2 m-0"></ui-keenicon>
  <span class="btn-label">{{ 'breadcrumbs.helpdesk' | transloco }}</span>
</a>
